export default "/images/PIXL8 - Mini Icon.png?b8f997b73627634bc907c505cb095f5d";